import React, { useState, Fragment, useLayoutEffect } from "react"
import { Link, useLocation } from "react-router-dom"
import { useSelector } from "react-redux"
import { Collapse } from "react-bootstrap"
import { FaChevronDown } from "react-icons/fa"
import clsx from "clsx"

import { navItems } from "constants"
import SideNavigationLogout from "./SideNavigationLogout"
import classes from "./SideNavigationItems.module.scss"
import { useTranslation } from "react-i18next"

const SideNavigationItems = (props) => {
  const { setOpenSidebar } = props

  const [t] = useTranslation()

  const location = useLocation()

  const accesses =
    useSelector((state) => state.userAccountInfo.accesses)

  const serviceTypeName =
    useSelector(state => state.systemSettings.serviceTypeName)

  const { notViewedOrders } =
    useSelector(state => state.notViewedOrders)

  const [openCollapse, setOpenCollapse] = useState([])
  const [pathname, setPathname] = useState(location.pathname)

  const showNavItem = (item) => (
    !!item.serviceTypeName
      ?
      item.serviceTypeName === serviceTypeName &&
      (
        accesses.hasFullAccess ||
        !!accesses[item.requiredAccess]
      )
      :
      accesses.hasFullAccess ||
      !!accesses[item.requiredAccess]
  )

  const showNavCollapse = (navItem) => (
    !!navItem.serviceTypeName
      ?
      navItem.serviceTypeName === serviceTypeName &&
      (
        accesses.hasFullAccess ||
        navItem.items.some(item => !!accesses[item.requiredAccess])
      )
      :
      accesses.hasFullAccess ||
      navItem.items.some(item => !!accesses[item.requiredAccess])
  )

  const handleOpenCollapse = (index) => {
    setOpenCollapse((prev) => {
      const array = [...prev]
      array[index] = !array[index]
      return array
    })
  }

  const handleCollapseAllExcept = (index) => {
    window.innerWidth < 1140 && setOpenSidebar(false)

    setOpenCollapse((prev) =>
      prev.map((colapse, i) => (index === i ? colapse : false))
    )
  }

  const openInitialCollapse = () => {
    navItems.forEach((navItem, index) => {
      if (!navItem.collapse) return

      const open =
        navItem.items.some((item) =>
          item.path === location.pathname
        )

      open && handleOpenCollapse(index)
    })
  }

  useLayoutEffect(() => {
    openInitialCollapse()
  }, [])

  useLayoutEffect(() => {
    setPathname(location.pathname)
  }, [location.pathname])

  const badgeFields = { ...notViewedOrders }

  return (
    <div className={classes["menu"]}>
      {navItems.map((navItem, index) =>
        showNavCollapse(navItem) &&
        <Fragment key={navItem.title}>
          {navItem.collapse
            ?
            <div
              onClick={() => handleOpenCollapse(index)}
              className={classes["menu-item"]}
            >
              <span className={classes["title"]}>
                {navItem.icon}
                <span className={classes["text"]}>
                  {t(navItem.title)}
                </span>
              </span>

              <FaChevronDown
                className={clsx(
                  classes["chevron"],
                  !!openCollapse[index] && classes["rotate"]
                )}
              />
            </div>
            :
            showNavItem(navItem) &&
            <Link
              key={navItem.path}
              onClick={() => handleCollapseAllExcept(index)}
              to={navItem.path}
              className={clsx(
                classes["menu-item"],
                navItem.path === pathname && classes["active"]
              )}
            >
              <span className={classes["title"]}>
                {navItem.icon}
                <span className={classes["text"]}>
                  {t(navItem.title)}
                </span>
              </span>
            </Link>
          }

          <Collapse in={!!openCollapse[index]}>
            <div className={classes["collapse"]}>
              {navItem.items.map((item) =>
                showNavItem(item) &&
                <Link
                  key={item.path}
                  onClick={() => handleCollapseAllExcept(index)}
                  to={item.path}
                >
                  <div className={classes["collapse-item"]}>
                    <span
                      className={clsx(
                        classes["collapse-item-text"],
                        item.path === pathname && classes["active"]
                      )}
                    >
                      {t(item.title)}
                    </span>

                    {
                      item.badge &&
                      badgeFields[item.badgeField] > 0 &&
                      <span className={classes["badge"]}>
                        {badgeFields[item.badgeField]}
                      </span>
                    }
                  </div>
                </Link>
              )}
            </div>
          </Collapse>
        </Fragment>
      )}

      <SideNavigationLogout />
    </div>
  )
}

export default SideNavigationItems
